module.exports = __webpack_public_path__ + "media/promo/courses/images/s3-737f336db47e0bc3aa5b72ab2ff98960.jpg";